import React from 'react';
import { useTranslation } from 'react-i18next';
import { Outlet } from 'react-router-dom';
import { Link } from 'react-router-dom';
import { Breadcrumb, BreadcrumbItem } from '@carbon/react';
import OrderQuotaBanner from 'src/components/Billing/OrderQuotaBanner';
import Toolbar from 'src/components/Dashboard/Toolbar';
import { useAuthSession } from 'src/hooks/useAuthSession';
import { useCurrentRestaurantBranch } from 'src/hooks/useRestaurantBranches';

const Dashboard = () => {
  const { t } = useTranslation('dashboard');
  const { user } = useAuthSession();
  const currentRestaurantBranch = useCurrentRestaurantBranch();
  return (
    <div className={'dashboard'}>
      <div className={'dashboard__main-content'}>
        <Breadcrumb noTrailingSlash aria-label="Page navigation">
          <BreadcrumbItem>
            <Link to="/dashboard/selling">{t('title')}</Link>
          </BreadcrumbItem>
          <BreadcrumbItem>
            <Link to="/dashboard/selling">{currentRestaurantBranch?.name || 'All'}</Link>
          </BreadcrumbItem>
        </Breadcrumb>
        <h1 className="dashboard__heading">
          {t('welcomeBack')}, {user?.name}
        </h1>
        <OrderQuotaBanner />
        <Toolbar />
        <Outlet />
      </div>
    </div>
  );
};

export default Dashboard;
